const HOST_URL = location.host;
const RUN      = ['system.nozomi210.com'];


$(function () {

    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'Login') {
        Login();
    } else if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'fc_help') {
        fc_help();
    } else if (bodyId === 'CustomerEditFin') {
        CustomerEditFin();
    } else if(bodyId === 'fcJoinThk') {
        fcJoinThk();
    }

    // ヘッダーメニューとSP時のバーガーメニューに「サイトトップ」へのリンクを追加する
    // 追加時にすでに本番公開済のため、開発でも本番に飛ばず
    $('#cmnheaditem_mypage').before(
        '<li id="cmnheaditem_fcsitetop" class="common_header_button">' +
            '<a id="cmnhead_button_fcsitetop" href="https://nozomi210.com/">サイトトップ</a>' +
        '</li>');

    // プライバシーポリシーのリンク先を変える
    setTimeout(function(){
        $('#contents a').each(function() {
            if($(this).text().indexOf('プライバシーポリシー') > -1) {
                $(this).attr("href", "").attr('href', '//www.watanabepro.co.jp/information/privacy.html');
                $(this).attr("target", "_blank");
            }
        })
    }, 500);

});

function Login() {

    // 新規入会ボタン下に注意事項追加
    $('#fcJoin_lnk').after('<div id="fcJoin_link-attention">※Loppi・ローチケWEBサイト・郵便振替にてお支払い済の場合、必ず下部「Loppi・ローチケWEBサイト・郵便振替でご入会いただいた方へ」よりお手続きください。<br>上記「新規入会」よりお手続きされると重複入会となりますので、ご注意ください。<br>なお、その場合も返金はできませんので、ご了承ください。</div>');

    // ログイン方法のお知らせを変える
    $('.fc_register_table .fc_register_heading').html('Loppi・ローチケWEBサイト・<br class="s-elem">郵便振替でご入会いただいた方へ');

    $('.fc_register_table .fc_register_panel').html(
        '「仮登録完了：本登録手続き・初回ログインのお願い」のメールが届きましたら、<br class="pc-elem"><a href="/v2/CustomerRegister.aspx?ccode=NZMT">こちら</a>よりお手続き・初回ログインをお願いいたします。<br>' +
        '※初回ログイン後は、「すでに会員の方はこちら」よりログインいただけます。'
    );
}

// Register
function pageRegister() {
    // $('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');
}

// RegisterStep1
function RegisterStep1() {
    // $('.table_label.col_must').each(function(){
    //     let $title = $(this);

    //     if($title.text().indexOf('郵便番号') > -1) {
    //         $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
    //     }
    // });
}

// MyPage
function MyPage() {
    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');
}

function fc_help() {
    $('.t_title').text('よくある質問');
}

function fcJoinThk() {
    const copyText = $('.fc_thanks_text').clone()[0];

    $('.alert-success').html(
                '入会申込を承りました。<br>入金確認後、「ご入会手続き完了のご案内メール」が届きますので、案内に従ってお手続きいただくと会員登録が完了となります。<br><br>' +
                '<div class="fc_thanks_text--add">' +
                '【クレジットカード入会の方】<br>決済が完了次第、「ご入会手続き完了のご案内メール」をお送りいたします。<br><br>' +
                '【コンビニ支払いの方】<br>お申込みより7日以内にお支払いをお願いいたします。入金確認ができましたら、「ご入会手続き完了のご案内メール」をお送りいたします。<br>' +
                '※期日までにお支払いがない場合、お申込みは無効となり、再度お支払い方法の選択から、お手続きいただく必要がございます。' +
                '</div>'
            );
    $('.alert-success').prepend(copyText);

}

// アコーディオン
$(function () {

    // クラス名定義
    var accordionTitleClass = 'js-accordion-title';
    var accordionBodyClass = 'js-accordion-body';
    var className = 'js-open';

    // titleごとに処理を実行
    $('.' + accordionTitleClass).each(function() {
        var $this = $(this);
        var $body = $this.nextAll('.' + accordionBodyClass);

        // あらかじめクラスが付いていたら初期表示でオープン
        if ($this.hasClass(className)) {
            $body.each( function() {
                $(this).show();
            });
        }

        // タイトルをクリックしたら開閉する
        $this.on('click', function() {
            $this.toggleClass(className);
            $body.each( function() {
                // $(this).toggleClass(className);
                $(this).slideToggle(250, 'linear');
            });
        });
    });
});

function CustomerEditFin() {
    $('.alert-success').html('会員情報を変更しました。');
}